import { render, staticRenderFns } from "./E2vSection.vue?vue&type=template&id=37840848&"
import script from "./E2vSection.vue?vue&type=script&lang=js&"
export * from "./E2vSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports